import { jsx as _jsx } from "react/jsx-runtime";
import PagesCommonHeader from "../../../common_components/PagesCommonHeader";
const LinkBuilderToolHeader = () => (_jsx(PagesCommonHeader, { height: "58px", title: "Link Builder Tool" }));
export default LinkBuilderToolHeader;
